<div
  id="trailer-intervention-report-map"
  class="trailer-intervention-report-map"
  leaflet
  [leafletOptions]="mapOptions"
  (leafletMapReady)="onMapReady($event)"
></div>
<app-map-layers-control
  [mapReady]="mapReady$"
  [layers]="layers"
  (loaded)="mapLayersControlLoaded($event)"
></app-map-layers-control>

<div class="heatmap-legend">
  <div>{{ intervention.trailer_name }}:</div>
  <div>
    <span style="background-color: #0080ff"></span>< {{ legendMin }}
    {{ legendUnit }}
  </div>
  <div>
    <span style="background-color: #00ff00"></span>< {{ legendMax }}
    {{ legendUnit }}
  </div>
  <div>
    <span style="background-color: #ff0000"></span>> {{ legendMax }}
    {{ legendUnit }}
  </div>
</div>

<dx-load-panel
  class="route-loading"
  shadingColor="rgba(0,0,0,0.2)"
  [(visible)]="isRouteLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="true"
>
  <div *dxTemplate="let data of 'content'">{{ routeLoader.loadedStr() }}</div>
</dx-load-panel>
